import { EXPRESS_API } from 'configs/api/expressApi';
import { CreateParams, CreateServiceParams } from '.';

export type GetServicesParams = {
  start?: number;
  limit?: number;
  search?: string;
  sort?: string;
  filterByActive?: string;
};

export const getServices = async (params: GetServicesParams) => {
  const response = await EXPRESS_API.get(`/services`, {
    params,
  });

  return response.data;
};

export const createService = async ({ data }: CreateServiceParams) => {
  // @ts-ignore
  delete data.serviceId;

  const response = await EXPRESS_API.post(`/services`, data);

  return response.data;
};

export const createServices = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/services/bulk', { services: data });

  return response.data;
};

export const updateService = async ({
  serviceId,
  data,
}: CreateServiceParams) => {
  const response = await EXPRESS_API.put(`/services/${serviceId}`, data);

  return response.data;
};

export const updateServices = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.put(`/services`, { services: data });

  return response.data;
};
